import { ChangePasswordForm } from "../components/ChangePasswordForm";

function ChangePassword() {
  return <ChangePasswordForm />;
}

export { ChangePassword };
